import { Component, Injector, OnInit } from '@angular/core';
import { UtilService } from '../../../../app/services/util.service';
import { DialogAbstractComponent } from '../../../../app/shared/dialogs/dialog.class';

@Component({
  selector: 'app-important-notice',
  templateUrl: './important-notice.component.html',
  styleUrls: ['./important-notice.component.scss'],
})
export class ImportantNoticeComponent extends DialogAbstractComponent implements OnInit {
  constructor(injector: Injector, private utilService: UtilService) {
    super(injector);
  }

  ngOnInit() {}
  async close() {
    if (this.dialogParams.featureStatus) {
      try {
        await this.utilService.disabledUserAlert();
      } catch (e) {}
    }
    this.closeDialog(false);
  }
}
